import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { FormValues } from '../../FirmSettings.meta';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { TermsModal } from './components/TermsModal/TermsModal';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const AIPdfReader = ({ formBag, ...rest }: Props) => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  const allowAiPdfReader = formBag.watch('allowAiPdfReader');

  return (
    <>
      <Box as="section" {...rest}>
        <SectionHeader title="AI PDF Reader" />

        <Toggle
          checked={allowAiPdfReader}
          onChange={evt => {
            if (evt.target.checked) {
              setIsTermsModalOpen(true);
            } else {
              formBag.setValue('allowAiPdfReader', false, { shouldDirty: true });
            }
          }}
          helperText={
            allowAiPdfReader ? (
              <>
                I&apos;ve read and accepted the{' '}
                <Button
                  variant="link"
                  size="small"
                  onClick={() => setIsTermsModalOpen(true)}
                  ml={2}
                >
                  Orion AI PDF Reader (Beta) Agreement
                </Button>
              </>
            ) : (
              ''
            )
          }
          mt="24"
        >
          Allow Advisors to Access AI PDF Reader
        </Toggle>
      </Box>

      {isTermsModalOpen && (
        <TermsModal
          onClose={() => {
            setIsTermsModalOpen(false);
          }}
          onAccept={() => {
            setIsTermsModalOpen(false);
            formBag.setValue('allowAiPdfReader', true, { shouldDirty: true });
            formBag.setValue('hasAcceptedAiPdfReaderTerms', true, { shouldDirty: true });
          }}
        />
      )}
    </>
  );
};
